export const gameRedirects = (rootURL: string, dynamicIdName: string) => {
  return {
    [`/slots/${rootURL}/[${dynamicIdName}]`]: `/slots/${rootURL}/[${dynamicIdName}]/[currencyName]`,
    [`/slots/${rootURL}/[${dynamicIdName}]/play`]: `/slots/${rootURL}/[${dynamicIdName}]/[currencyName]/play`,
    [`/slots/${rootURL}/[${dynamicIdName}]/play/mobile`]: `/slots/${rootURL}/[${dynamicIdName}]/[currencyName]/play/mobile`,

    [`/slots/${rootURL}/[${dynamicIdName}]/[currencyName]`]: `/slots/${rootURL}/[${dynamicIdName}]`,
    [`/slots/${rootURL}/[${dynamicIdName}]/[currencyName]/play`]: `/slots/${rootURL}/[${dynamicIdName}]/play`,
    [`/slots/${rootURL}/[${dynamicIdName}]/[currencyName]/play/mobile`]: `/slots/${rootURL}/[${dynamicIdName}]/play/mobile`,
  }
}
export const gameRoutesGenerator = (rootUrl: string, dynamicIdName: string) => {
  return {
    [`/slots/${rootUrl}/[${dynamicIdName}]`]: (route: string) => `/slots/${rootUrl}/${route}`,

    [`/slots/${rootUrl}/[${dynamicIdName}]/play`]: (route: string) => `/slots/${rootUrl}/${route}/play`,

    [`/slots/${rootUrl}/[${dynamicIdName}]/play/mobile`]: (route: string) => `/slots/${rootUrl}/${route}/play/mobile`,

    [`/slots/${rootUrl}/[${dynamicIdName}]/[currencyName]`]: (route: string, currencyName: string) =>
      `/slots/${rootUrl}/${route}/${currencyName}`,

    [`/slots/${rootUrl}/[${dynamicIdName}]/[currencyName]/play`]: (route: string, currencyName: string) =>
      `/slots/${rootUrl}/${route}/${currencyName}/play`,

    [`/slots/${rootUrl}/[${dynamicIdName}]/[currencyName]/play/mobile`]: (route: string, currencyName: string) =>
      `/slots/${rootUrl}/${route}/${currencyName}/play/mobile`,
  }
}

export function getSlotStartUrlByGameType(isTableGame: boolean, isSlingo: boolean, isArcadeGame: boolean) {
  if (isArcadeGame) {
    return 'casual-games'
  } else if (isSlingo) {
    return 'slingo'
  } else if (isTableGame) {
    return 'table-games'
  } else {
    return 'slots'
  }
}
